import api from './api-v1';

// Create/update new Lignes
// Add ligne
export const addFeuilleLigne = async (data) => {
  try {
    const response = await api.post(`/lignes/add_columns`, data);
    return response.data;
  } catch (error) {
    console.error('Error adding ligne columns:', error);
    throw error;
  }
};

export const updateFeuilleLigne = async (data) => {
  try {
    const response = await api.put('/lignes/update_columns', data);
    return response.data;	
  } catch (error) {
    console.error('Error updating ligne columns:', error);
    throw error;
  }
};

// Update ligne rang
export const updateFeuilleLigneRang = async (data) => {
  try {
    const response = await api.post(`/lignes/update_rang`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating ligne rang:', error);
    throw error;
  }
};

// Drop ligne columns
export const deleteFeuilleLigneColumns = async (data) => {
  try {
    const response = await api.post(`/lignes/drop_columns`, data);
    return response.data;
  } catch (error) {
    console.error('Error dropping ligne columns:', error);
    throw error;
  }
};

// Get all lignes
export const getFeuilleLignes = async () => {
  try {
    const response = await api.get('/lignes');
    return response.data;
  } catch (error) {
    console.error('Error fetching lignes:', error);
    throw error;
  }
};

// Get ligne by id
export const getFeuilleLigneID = async (id) => {
  try {
    const response = await api.get(`/lignes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching ligne:', error);
    throw error;
  }
};